import { render, staticRenderFns } from "./CreditConsumption.vue?vue&type=template&id=cd54b16e&scoped=true&"
import script from "./CreditConsumption.vue?vue&type=script&lang=js&"
export * from "./CreditConsumption.vue?vue&type=script&lang=js&"
import style0 from "./CreditConsumption.vue?vue&type=style&index=0&id=cd54b16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd54b16e",
  null
  
)

export default component.exports